const zh_hant = {
  create: "創建文章",
  update: "文檔信息修改",
  generate: "生成",
  textTitle: "閱讀材料",
  word: "打開文章",
  multiMedia: "打開多媒体",
  file: " Word"
};
const en = {
  create: "Add Word",
  generate: "Generate",
  textTitle: "Reading material",
  word: "Check file",
  multiMedia: "Multi-media",
  file: " Word"
};
const zh_cn = {
  create: "创建文章",
  update: "编辑文章信息",
  generate: "生成",
  textTitle: "阅读材料",
  word: "打开文章",
  multiMedia: "打开多媒体",
  file: " Word"
};
const es = {
  create: "Crear artículo",
  update: "Modificar información del documento",
  generate: "Generar",
  textTitle: "Material de lectura",
  word: "Abrir artículo",
  multiMedia: "Abrir multimedia",
  file: "Word"
};
export default {
  zh_cn,
  zh_hant,
  en,
  es
};
